import { EligibilityProvider } from "@/components/landing/EligibilityContext";
import { StatsBand } from "@/components/landing/StatsBand";
import { OnlineAnnouncementBar, OnlineNavbar } from "@/components/online/OnlineNavbar";
import { OnlineHero } from "@/components/online/OnlineHero";
import { OnlineDifferent } from "@/components/online/OnlineDifferent";
import { OnlineClassInAction } from "@/components/online/OnlineClassInAction";
import { OnlineRoadmap } from "@/components/online/OnlineRoadmap";
import { OnlineJoin } from "@/components/online/OnlineJoin";
import { OnlineProblems } from "@/components/online/OnlineProblems";
import { OnlineAdvantage } from "@/components/online/OnlineAdvantage";
import { OnlineLearn } from "@/components/online/OnlineLearn";
import { OnlineRiskFree } from "@/components/online/OnlineRiskFree";
import { OnlineTestimonials } from "@/components/online/OnlineTestimonials";
import { OnlinePromise } from "@/components/online/OnlinePromise";
import { OnlineFinalCTA } from "@/components/online/OnlineFinalCTA";
import { OnlineFooter } from "@/components/online/OnlineFooter";
import { OnlineStickyBar } from "@/components/online/OnlineStickyBar";

export default function OnlineLanding() {
  return (
    <EligibilityProvider>
      <div className="min-h-screen overflow-x-clip bg-ink text-offwhite" data-testid="online-landing-page">
        <OnlineAnnouncementBar />
        <OnlineNavbar />
        <main className="pb-24 md:pb-0">
          <OnlineHero />
          <StatsBand />
          <OnlineDifferent />
          <OnlineClassInAction />
          <OnlineRoadmap />
          <OnlineJoin />
          <OnlineProblems />
          <OnlineAdvantage />
          <OnlineLearn />
          <OnlineRiskFree />
          <OnlineTestimonials />
          <OnlinePromise />
          <OnlineFinalCTA />
        </main>
        <OnlineFooter />
        <OnlineStickyBar />
      </div>
    </EligibilityProvider>
  );
}
